/* @flow */

export default class PaymentOgoneValue {
  key: string;
  value: string;
}
